<div class="campaign-card-promo-details-container" [class.high-contrast]="highContrast()" *transloco="let t">
  @if (campaignUserStatus() == CampaignUserStatus.ACTIVE  && remainingRewards() && totalRewards()) {
    <div class="details-row">
      <img ngSrc="/assets/icons/coupon-line.svg" alt="coupon line" height="16" width="16">
      <div class="details-text-row">
              <span class="details-text" [class.light]="lightFont()">{{
                  t('actions.card.rewardsRatio',
                    {total: totalRewards() | loyaltyNumber, remaining: remainingRewards() | loyaltyNumber})
                }}</span>
      </div>
    </div>
  }

  <lib-campaign-time-conditions-details [campaign]="campaign()"
                                        [lightFont]="lightFont()"></lib-campaign-time-conditions-details>
  @if (displayLocation() && location()) {
    <div class="details-row">
      <img ngSrc="/assets/icons/location-Icon.svg" alt="location icon" height="16"
           width="16">
      <span class="details-text location" [class.light]="lightFont()">{{ location() }}</span>
    </div>
  }
</div>
